import { LazyLoad } from 'app/utils';

export const LogoutPage = LazyLoad(
  () => import('./index'),
  (module) => module.LogoutPage,
);
